/* eslint-disable flowtype/require-valid-file-annotation */
const { ROOT_LOCALE } = require('./constants');

function safeLink(link) {
  if (!link) return `/${ROOT_LOCALE}/`;
  if (link.indexOf('http') === 0 || link.indexOf('//') === 0) return link;
  const [, path, query, hash] = /([^?#]*)([^#]*)(.*)/.exec(link);
  return `/${path}/${query}${hash}`.replace(/\/+/gi, '/');
}

module.exports = {
  safeLink
};
